import { SVGProps } from 'react'

export const NotificationDot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="8"
      cy="8.5"
      r="6"
      fill="#1CAEFF"
      stroke="#AAE1FF"
      strokeWidth="4"
    />
  </svg>
)
